$(document).ready(function(){
   $(document).on("click",".ajax__add-to-cart",function() {
      const variantId = $(this).attr("data-variant");
      console.log(variantId)
      $.ajax({
        type:"POST",
        url:"/cart/add.js",
        data:{items: [{ id: variantId, quantity: 1 }]},
        dataType:"json",
        success:function(data) {
          window.location.href="/cart";
        },
        error:function(error) {
          console.log(error);
        }
      })
   })
})